$(document).ready(function () {
  $(".collection-slideshow").slick({
    dots: false,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: false,
    speed: 900,
    autoplaySpeed: 700,
    prevArrow: $(".prev"),
    nextArrow: $(".next"),
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 550,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  });
});

// $(".testimonial-carousel").slick({
//   centerMode: true,
//   centerPadding: "60px",
//   slidesToScroll: 1,
//   slidesToShow: 1,
//   responsive: [
//     {
//       breakpoint: 768,
//       settings: {
//         arrows: false,
//         centerMode: true,
//         centerPadding: "40px",
//         slidesToShow: 3,
//       },
//     },
//     {
//       breakpoint: 480,
//       settings: {
//         arrows: false,
//         centerMode: true,
//         centerPadding: "40px",
//         slidesToShow: 1,
//       },
//     },
//   ],
// });

$("#testimonial-slider").slick({
  centerMode: true,
  slidesToShow: 1,
  arrows: true,
  dots: false,
  autoplay: false,
  centerPadding: "20px",
  autoplaySpeed: 2000,
  prevArrow: '<span class="prev-arrow"><svg xmlns="http://www.w3.org/2000/svg" class="icon icon-caret width="16" height="16" viewBox="0 0 9 13" fill="none"><path d="M7.75 12L1.75 6L7.75 0" stroke="#1A1A1A" stroke-width="2" stroke-linejoin="round"/></svg></span>',
  nextArrow: '<span class="next-arrow"><svg xmlns="http://www.w3.org/2000/svg" class="icon icon-caret width="16" height="16" viewBox="0 0 8 13" fill="none"><path d="M1 12L7 6L1 0" stroke="#1A1A1A" stroke-width="2" stroke-linejoin="round"/></svg></span>',
  responsive: [
    {
      breakpoint: 768,
      settings: {
        arrows: true,
        centerMode: false,
        slidesToShow: 1,
      },
    },
    {
      breakpoint: 480,
      settings: {
        arrows: true,
        centerMode: false,
        slidesToShow: 1,
      },
    },
  ],
});